// extracted by mini-css-extract-plugin
export default {"screen":"Splash_screen__Ey8nO","page":"Splash_page__XhD9d","inCard":"Splash_inCard__Qp1ea"};